/*!
 * AMOUR amour.si / amourparfums.* — Qikify Smart Cart i18n shim.
 *
 * Rewrites Qikify Smart Cart v2 strings that the app cannot localize
 * (Apply button, aria-labels, confirm dialogs) and, for Polish (pl),
 * injects a full scTranslation.pl pack + overrides SI merchant defaults
 * that otherwise leak onto amourparfums.pl.
 *
 * Maintained by scripts/_pl-i18n/patch-qikify-pl.ts
 */
(function () {
  'use strict';
/* AMOUR_QIKIFY_MALWARE_GUARD_START */
(function amourQikifyMalwareGuard() {
  'use strict';

  var SAFE_MSG = {
    pl: '<i>Koszty wysyłki i podatki są obliczane przy kasie</i>',
    sl: '<i>Stroški dostave in davki se izračunajo na blagajni</i>',
    de: '<i>Versandkosten und Steuern werden an der Kasse berechnet</i>',
    hr: '<i>Troškovi dostave i porezi obračunavaju se na blagajni</i>',
    it: '<i>Spese di spedizione e tasse calcolate al checkout</i>',
    hu: '<i>A szállítási díj és az adók a pénztárnál kerülnek kiszámításra</i>',
    nl: '<i>Verzendkosten en belastingen worden berekend bij het afrekenen</i>',
    fr: '<i>Frais de livraison et taxes calculés à la caisse</i>',
    en: '<i>Shipping and taxes are calculated at checkout</i>'
  };
  var SAFE_EMPTY = {
    pl: 'Twój koszyk jest obecnie pusty.',
    sl: 'Vaša košarica je trenutno prazna.',
    de: 'Dein Warenkorb ist derzeit leer.',
    hr: 'Vaša košarica je trenutno prazna.',
    it: 'Il tuo carrello è attualmente vuoto.',
    hu: 'A kosarad jelenleg üres.',
    nl: 'Je winkelwagen is momenteel leeg.',
    fr: 'Votre panier est actuellement vide.',
    en: 'Your cart is currently empty.'
  };

  function loc() {
    try {
      if (window.Shopify && Shopify.locale) return String(Shopify.locale).slice(0, 2).toLowerCase();
    } catch (e) {}
    return String(document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
  }
  function isBad(v) {
    // String checks only — regex literals inside this template string are unsafe
    // (\s / \( get eaten by the TS template), which previously shipped a broken
    // /...\(/i pattern ("Unterminated group") and disabled the whole guard.
    var s = String(v || '');
    var low = s.toLowerCase();
    if (low.indexOf('qikify_stickycart') !== -1) return true;
    if (low.indexOf('__checkiout') !== -1) return true;
    if (low.indexOf('__qikify_jwt') !== -1) return true;
    if (low.indexOf('trendpay') !== -1) return true;
    if (low.indexOf('paytrend') !== -1) return true;
    if (low.indexOf('onerror') !== -1 && low.indexOf('=') !== -1) return true;
    if (low.indexOf('atob') !== -1 && low.indexOf('(') !== -1) return true;
    if (low.indexOf('eval') !== -1 && low.indexOf('(') !== -1) return true;
    if (low.indexOf('textdecoder') !== -1 && low.indexOf('uint8array') !== -1) return true;
    return false;
  }
  function safeMsg() { return SAFE_MSG[loc()] || SAFE_MSG.en; }
  function safeEmpty() { return SAFE_EMPTY[loc()] || SAFE_EMPTY.en; }

  function scrubSettings() {
    try {
      var root = window.Qsc2Data;
      if (!root) return false;
      var settings = root.settings;
      var data = settings && (settings.data || settings);
      if (!data || typeof data !== 'object') return false;
      var cleaned = false;
      if (isBad(data.sc_cart_message)) { data.sc_cart_message = safeMsg(); cleaned = true; }
      if (isBad(data.sc_cart_empty_text)) { data.sc_cart_empty_text = safeEmpty(); cleaned = true; }
      // Also wipe malware if it leaked into translation packs
      try {
        var tr = root.scTranslation || {};
        Object.keys(tr).forEach(function (lang) {
          var pack = tr[lang];
          if (!pack || typeof pack !== 'object') return;
          if (isBad(pack.sc_cart_message)) pack.sc_cart_message = safeMsg();
          if (isBad(pack.sc_cart_empty_text)) pack.sc_cart_empty_text = safeEmpty();
        });
      } catch (e2) {}
      if (cleaned) {
        try { console.info('[amour] neutralized Qikify checkout-hijack HTML in Sticky Cart settings'); } catch (e3) {}
      }
      return true;
    } catch (e) { return false; }
  }

  function scrubNode(node) {
    if (!node || node.nodeType !== 1) return;
    try {
      if (node.id && /^QIKIFY_STICKYCART/i.test(node.id)) { node.remove(); return; }
      if (node.tagName === 'IMG') {
        var src = node.getAttribute('src') || '';
        var onerr = node.getAttribute('onerror') || '';
        if (/__qikify|QIKIFY_STICKYCART|atob|CHECKIOUT|trendpay|paytrend/i.test(src + onerr)) {
          node.removeAttribute('onerror');
          node.remove();
          return;
        }
      }
      if (node.getAttribute && isBad(node.getAttribute('onerror') || '')) {
        node.removeAttribute('onerror');
        node.remove();
      }
    } catch (e) {}
  }

  function scrubDom(root) {
    try {
      var scope = root || document;
      if (!scope.querySelectorAll) return;
      scope.querySelectorAll('[id^="QIKIFY_STICKYCART"], img[src*="__qikify"], img[onerror], [onerror]').forEach(scrubNode);
    } catch (e) {}
  }

  function blockBadNavigation() {
    try {
      var badHost = /(?:^|\.)(?:trendpay|paytrend)\.top$/i;
      var origOpen = window.open;
      window.open = function (url) {
        try {
          var u = String(url || '');
          if (badHost.test((new URL(u, location.href)).hostname)) {
            console.warn('[amour] blocked fraudulent checkout window', u);
            return null;
          }
        } catch (e) {}
        return origOpen.apply(this, arguments);
      };
      document.addEventListener('click', function (ev) {
        try {
          var a = ev.target && ev.target.closest && ev.target.closest('a[href]');
          if (!a) return;
          var href = a.getAttribute('href') || '';
          if (/trendpay\.top|paytrend\.top/i.test(href)) {
            ev.preventDefault();
            ev.stopPropagation();
            console.warn('[amour] blocked fraudulent checkout link', href);
          }
        } catch (e) {}
      }, true);
    } catch (e) {}
  }

  function start() {
    blockBadNavigation();
    scrubSettings();
    scrubDom(document);
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      scrubSettings();
      scrubDom(document);
      if (tries > 200) clearInterval(iv);
    }, 50);
    try {
      var mo = new MutationObserver(function (muts) {
        scrubSettings();
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.addedNodes) {
            for (var j = 0; j < m.addedNodes.length; j++) {
              var n = m.addedNodes[j];
              scrubNode(n);
              if (n && n.querySelectorAll) scrubDom(n);
            }
          }
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
    // Also race settings as soon as the inline Qsc2Data script defines them
    var early = setInterval(function () {
      if (scrubSettings()) { /* keep watching via start() */ }
    }, 5);
    setTimeout(function () { clearInterval(early); }, 20000);
  } else {
    start();
  }

})();
/* AMOUR_QIKIFY_MALWARE_GUARD_END */



  var HOST_OK =
    /(^|\.)amour\.si$/i.test(window.location.hostname) ||
    /(^|\.)amour-parfums-2\.myshopify\.com$/i.test(window.location.hostname) ||
    /(^|\.)amourparfums\.(com|de|hr|it|nl|at|pl)$/i.test(window.location.hostname) ||
    /(^|\.)amour\.hu$/i.test(window.location.hostname) ||
    /(^|\.)parfumerija-amour\.myshopify\.com$/i.test(window.location.hostname);
  if (!HOST_OK) return;

  function getLocale() {
    try {
      if (window.Shopify && Shopify.locale) {
        return String(Shopify.locale).slice(0, 2).toLowerCase();
      }
    } catch (_) { /* ignore */ }
    var htmlLang = (document.documentElement.getAttribute('lang') || '')
      .slice(0, 2)
      .toLowerCase();
    return htmlLang || 'en';
  }

  // Full Polish pack for Qikify scTranslation / settings.data keys
  var PL_SC = {
    sc_cart_empty_text: 'Twój koszyk jest obecnie pusty.',
    sc_cart_empty_button_text: 'Kontynuuj zakupy',
    sc_product_item_error_message: 'Niewystarczająca liczba produktów.',
    sc_show_bundle_text: 'Pokaż produkty ({numberOfProducts})',
    sc_hide_bundle_text: 'Ukryj produkty ({numberOfProducts})',
    sc_subtotal_label: 'Suma częściowa',
    sc_discount_label: 'Łączne oszczędności',
    sc_checkout_label: 'Przejdź do kasy',
    sc_cart_message: '<i>Koszty wysyłki i podatki są obliczane przy kasie</i>',
    sc_continue_shopping_label: 'Kontynuuj zakupy',
    sc_goto_cart_label: 'Zobacz koszyk',
    sc_feature_note_label: 'Dodaj notatkę do zamówienia (opcjonalnie)',
    sc_feature_note_placeholder: 'Specjalne instrukcje dla sprzedawcy',
    sc_feature_note_title: 'Dodaj notatkę dla sprzedawcy',
    sc_feature_note_action: 'Zapisz',
    sc_recommendation_label: 'Polecane produkty',
    sc_recommendation_button_label: 'Dodaj',
    sc_countdown_message: '🔥 Te produkty są dostępne w ograniczonej ilości',
    sc_goal_reminder: 'Kup jeszcze za <strong> ${amount} </strong>, aby skorzystać z <strong> BEZPŁATNEJ WYSYŁKI </strong>',
    sc_goal_done_message: 'Gratulacje! Przysługuje Ci <strong> BEZPŁATNA WYSYŁKA </strong>',
    sc_edit_variant_title: 'Edytuj opcje',
    sc_add_to_cart_label: 'Dodaj do koszyka',
    sc_unavailable_label: 'Niedostępne',
    sc_sold_out_label: 'Wyprzedane',
    sc_feature_shipping_title: 'Oblicz koszty wysyłki',
    sc_feature_shipping_label: 'Oblicz koszty wysyłki',
    sc_feature_shipping_action: 'Oblicz koszty wysyłki',
    sc_feature_shipping_empty_rates: 'Brak dostępnych metod wysyłki',
    sc_feature_shipping_found_rates: 'Znaleźliśmy {numOfRates} opcji wysyłki dla Twojego adresu',
    sc_feature_discount_title: 'Dodaj kod rabatowy',
    sc_feature_discount_label: 'Użyj kodu',
    sc_feature_discount_description: '* Rabat zostanie obliczony i zastosowany przy kasie',
    sc_feature_discount_placeholder: 'Wpisz kod rabatowy',
    sc_feature_discount_action: 'Zapisz',
    sc_invalid_discount_code_message: 'Wpisz prawidłowy kod rabatowy',
    sc_gift_wrapping_note: 'Wiadomość prezentowa (bezpłatna i opcjonalna)',
    sc_gift_wrapping_checkbox_text: 'Za {priceOfWrapping} spakujemy produkty jako prezent.',
    sc_shipping_protection_title: 'Ochrona przesyłki',
    sc_shipping_protection_desc: 'Chroń zamówienie przed uszkodzeniem, zagubieniem i kradzieżą za {price}',
    sc_term_message: "Zgadzam się z <a href='/policies/terms-of-service'> Regulaminem </a>",
    sc_header_title: 'Twój koszyk',
    tier_undefined_promoted_message: 'Kup jeszcze za <strong> ${amount} </strong>, aby skorzystać z <strong> BEZPŁATNEJ WYSYŁKI </strong>',
    tier_undefined_archived_message: 'Gratulacje! Przysługuje Ci <strong> BEZPŁATNA WYSYŁKA </strong>',
  };

  function injectPlPack() {
    try {
      window.Qsc2Data = window.Qsc2Data || {};
      window.Qsc2Data.scTranslation = window.Qsc2Data.scTranslation || {};
      window.Qsc2Data.scTranslation.pl = Object.assign({}, PL_SC, window.Qsc2Data.scTranslation.pl || {});
      var settings = window.Qsc2Data.settings;
      var data = settings && (settings.data || settings);
      if (data && typeof data === 'object') {
        Object.keys(PL_SC).forEach(function (k) {
          if (Object.prototype.hasOwnProperty.call(data, k) || k === 'sc_header_title') {
            data[k] = PL_SC[k];
          }
        });
      }
    } catch (_) { /* ignore */ }
  }

  var DICT = {
    sl: {
      'Apply': 'Uporabi',
      'Apply Code': 'Uporabi kodo',
      'Apply code': 'Uporabi kodo',
      'Save': 'Shrani',
      'Add': 'Dodaj',
      'Add to cart': 'Dodaj v košarico',
      'Add to cart button': 'Dodaj v košarico',
      'Checkout': 'Na blagajno',
      'Checkout button': 'Na blagajno',
      'Continue Shopping': 'Nadaljuj nakupovanje',
      'Continue shopping': 'Nadaljuj nakupovanje',
      'Close cart': 'Zapri košarico',
      'Close': 'Zapri',
      'Clear all items in your cart?': 'Odstranim vse izdelke iz košarice?',
      'Decrease quantity button': 'Zmanjšaj količino',
      'Increase quantity button': 'Povečaj količino',
      'Remove item button': 'Odstrani izdelek',
      'Quantity input': 'Količina',
      'Quantity': 'Količina',
      'Previous': 'Prejšnji',
      'Next': 'Naslednji',
      'Subtotal': 'Vmesni znesek',
      'Total': 'Skupaj',
      'Remove': 'Odstrani',
      'Yes': 'Da',
      'No': 'Ne',
      'Cancel': 'Prekliči',
      'OK': 'V redu',
    },
    de: {
      'Apply': 'Anwenden',
      'Apply Code': 'Code anwenden',
      'Apply code': 'Code anwenden',
      'Save': 'Speichern',
      'Add': 'Hinzufügen',
      'Add to cart': 'In den Warenkorb',
      'Add to cart button': 'In den Warenkorb',
      'Checkout': 'Zur Kasse',
      'Checkout button': 'Zur Kasse',
      'Continue Shopping': 'Weiter einkaufen',
      'Continue shopping': 'Weiter einkaufen',
      'Close cart': 'Warenkorb schließen',
      'Close': 'Schließen',
      'Clear all items in your cart?': 'Alle Artikel aus dem Warenkorb entfernen?',
      'Decrease quantity button': 'Menge verringern',
      'Increase quantity button': 'Menge erhöhen',
      'Remove item button': 'Artikel entfernen',
      'Quantity input': 'Menge',
      'Quantity': 'Menge',
      'Previous': 'Zurück',
      'Next': 'Weiter',
      'Subtotal': 'Zwischensumme',
      'Total': 'Gesamt',
      'Remove': 'Entfernen',
      'Yes': 'Ja',
      'No': 'Nein',
      'Cancel': 'Abbrechen',
      'OK': 'OK',
    },
    hr: {
      'Apply': 'Primijeni',
      'Apply Code': 'Primijeni kod',
      'Apply code': 'Primijeni kod',
      'Save': 'Spremi',
      'Add': 'Dodaj',
      'Add to cart': 'Dodaj u košaricu',
      'Add to cart button': 'Dodaj u košaricu',
      'Checkout': 'Na blagajnu',
      'Checkout button': 'Na blagajnu',
      'Continue Shopping': 'Nastavi kupovati',
      'Continue shopping': 'Nastavi kupovati',
      'Close cart': 'Zatvori košaricu',
      'Close': 'Zatvori',
      'Clear all items in your cart?': 'Ukloniti sve artikle iz košarice?',
      'Decrease quantity button': 'Smanji količinu',
      'Increase quantity button': 'Povećaj količinu',
      'Remove item button': 'Ukloni artikl',
      'Quantity input': 'Količina',
      'Quantity': 'Količina',
      'Previous': 'Prethodno',
      'Next': 'Sljedeće',
      'Subtotal': 'Međuzbroj',
      'Total': 'Ukupno',
      'Remove': 'Ukloni',
      'Yes': 'Da',
      'No': 'Ne',
      'Cancel': 'Otkaži',
      'OK': 'OK',
    },
    hu: {
      'Apply': 'Alkalmaz',
      'Apply Code': 'Kód alkalmazása',
      'Apply code': 'Kód alkalmazása',
      'Save': 'Mentés',
      'Add': 'Hozzáadás',
      'Add to cart': 'Kosárba',
      'Add to cart button': 'Kosárba',
      'Checkout': 'Pénztár',
      'Checkout button': 'Pénztár',
      'Continue Shopping': 'Vásárlás folytatása',
      'Continue shopping': 'Vásárlás folytatása',
      'Close cart': 'Kosár bezárása',
      'Close': 'Bezárás',
      'Clear all items in your cart?': 'Eltávolítja az összes terméket a kosárból?',
      'Decrease quantity button': 'Mennyiség csökkentése',
      'Increase quantity button': 'Mennyiség növelése',
      'Remove item button': 'Termék eltávolítása',
      'Quantity input': 'Mennyiség',
      'Quantity': 'Mennyiség',
      'Previous': 'Előző',
      'Next': 'Következő',
      'Subtotal': 'Részösszeg',
      'Total': 'Összesen',
      'Remove': 'Eltávolítás',
      'Yes': 'Igen',
      'No': 'Nem',
      'Cancel': 'Mégse',
      'OK': 'Rendben',
    },
    it: {
      'Apply': 'Applica',
      'Apply Code': 'Applica codice',
      'Apply code': 'Applica codice',
      'Save': 'Salva',
      'Add': 'Aggiungi',
      'Add to cart': 'Aggiungi al carrello',
      'Add to cart button': 'Aggiungi al carrello',
      'Checkout': 'Vai alla cassa',
      'Checkout button': 'Vai alla cassa',
      'Continue Shopping': 'Continua a fare acquisti',
      'Continue shopping': 'Continua a fare acquisti',
      'Close cart': 'Chiudi carrello',
      'Close': 'Chiudi',
      'Clear all items in your cart?': 'Rimuovere tutti gli articoli dal carrello?',
      'Decrease quantity button': 'Diminuisci quantità',
      'Increase quantity button': 'Aumenta quantità',
      'Remove item button': 'Rimuovi articolo',
      'Quantity input': 'Quantità',
      'Quantity': 'Quantità',
      'Previous': 'Precedente',
      'Next': 'Successivo',
      'Subtotal': 'Subtotale',
      'Total': 'Totale',
      'Remove': 'Rimuovi',
      'Yes': 'Sì',
      'No': 'No',
      'Cancel': 'Annulla',
      'OK': 'OK',
    },
    // EN + SI merchant-default leftovers → Polish
    pl: {
      'Apply': 'Zastosuj',
      'Apply Code': 'Użyj kodu',
      'Apply code': 'Użyj kodu',
      'Uporabi kodo': 'Użyj kodu',
      'Uporabi': 'Zastosuj',
      'Save': 'Zapisz',
      'Shrani': 'Zapisz',
      'Add': 'Dodaj',
      'Dodaj': 'Dodaj',
      'Add to cart': 'Dodaj do koszyka',
      'Add to cart button': 'Dodaj do koszyka',
      'Dodaj v košarico': 'Dodaj do koszyka',
      'Checkout': 'Przejdź do kasy',
      'Checkout button': 'Przejdź do kasy',
      'Na blagajno': 'Przejdź do kasy',
      'Continue Shopping': 'Kontynuuj zakupy',
      'Continue shopping': 'Kontynuuj zakupy',
      'Nadaljujte z nakupovanjem': 'Kontynuuj zakupy',
      'Nadaljuj z nakupovanjem': 'Kontynuuj zakupy',
      'Nadaljuj nakupovanje': 'Kontynuuj zakupy',
      'Close cart': 'Zamknij koszyk',
      'Close': 'Zamknij',
      'Zapri košarico': 'Zamknij koszyk',
      'Clear all items in your cart?': 'Usunąć wszystkie produkty z koszyka?',
      'Decrease quantity button': 'Zmniejsz ilość',
      'Increase quantity button': 'Zwiększ ilość',
      'Remove item button': 'Usuń produkt',
      'Quantity input': 'Ilość',
      'Quantity': 'Ilość',
      'Previous': 'Poprzedni',
      'Next': 'Następny',
      'Subtotal': 'Suma częściowa',
      'Vmesni seštevek': 'Suma częściowa',
      'Vmesni znesek': 'Suma częściowa',
      'Total': 'Razem',
      'Remove': 'Usuń',
      'Yes': 'Tak',
      'No': 'Nie',
      'Cancel': 'Anuluj',
      'OK': 'OK',
      'Your cart': 'Twój koszyk',
      'Cart': 'Koszyk',
      'Priporočeni izdelki': 'Polecane produkty',
      'Recommended Products': 'Polecane produkty',
      'Goes great with': 'Pasuje idealnie do',
      'View cart': 'Zobacz koszyk',
      'Shipping fee and tax are calculated at checkout': 'Koszty wysyłki i podatki są obliczane przy kasie',
      'Shipping, taxes, and discount codes calculated at checkout.': 'Wysyłka, podatki i kody rabatowe zostaną obliczone przy kasie.',
    },
  };

  var loc = getLocale();

  // Polish: inject translation pack early + keep retrying until Qsc2Data exists
  if (loc === 'pl') {
    injectPlPack();
    var tries = 0;
    var inj = setInterval(function () {
      tries++;
      injectPlPack();
      if ((window.Qsc2Data && window.Qsc2Data.scTranslation && window.Qsc2Data.scTranslation.pl) || tries > 40) {
        clearInterval(inj);
      }
    }, 100);
  }

  var dict = DICT[loc];
  if (!dict) return;

  var ciMap = Object.create(null);
  Object.keys(dict).forEach(function (k) { ciMap[k.toLowerCase()] = dict[k]; });

  function lookup(text) {
    if (!text) return null;
    var key = String(text).trim().toLowerCase();
    if (!key) return null;
    return ciMap[key] || null;
  }

  // Partial / dynamic goal lines (amount varies)
  function lookupFlexible(text) {
    var t = lookup(text);
    if (t) return t;
    if (!text) return null;
    var s = String(text).trim();
    // EN goal
    var m = s.match(/^Buy\s+(.+?)\s+more to enjoy\s+FREE Shipping$/i);
    if (m && loc === 'pl') return 'Kup jeszcze za ' + m[1] + ', aby skorzystać z BEZPŁATNEJ WYSYŁKI';
    // SI goal
    m = s.match(/^Kupite še za\s+(.+?),\s*da boste uživali v\s+BREZPLAČNI DOSTAVI$/i);
    if (m && loc === 'pl') return 'Kup jeszcze za ' + m[1] + ', aby skorzystać z BEZPŁATNEJ WYSYŁKI';
    // terms SI
    if (/^Strinjam se s\s+/i.test(s) && /Pogoji/i.test(s) && loc === 'pl') {
      return s.replace(/Strinjam se s/i, 'Zgadzam się z').replace(/Pogoji poslovanja/i, 'Regulaminem');
    }
    return null;
  }

  var DRAWER_ROOTS = [
    '.qsc2-mini-cart',
    '.qsc2-cart-drawer',
    '.qsc2-slidecart',
    '[data-qsc2-drawer]',
  ].join(',');

  var TEXT_SELECTORS = [
    '.qsc2-sf-content__action-btn',
    DRAWER_ROOTS.split(',').map(function (s) { return s.trim() + ' [class*="qsc2-btn"]'; }).join(','),
    '.qsc2-mini-cart .qsc2-r-product__action',
    '.qsc2-cart-drawer .qsc2-r-product__action',
    '.qsc2-drawer-header__label',
    '.qsc2-mini-cart [class*="header"]',
  ].join(',');

  var ARIA_SELECTORS = DRAWER_ROOTS.split(',').map(function (s) {
    return s.trim() + ' [aria-label]';
  }).join(',');

  function translateText(node) {
    if (!node || node.dataset.amourI18n === '1') return;
    var text = (node.textContent || '').trim();
    if (!text) return;
    var translated = lookupFlexible(text);
    if (!translated) return;
    var replaced = false;
    for (var i = 0; i < node.childNodes.length; i++) {
      var c = node.childNodes[i];
      if (c.nodeType === 3 && c.nodeValue && c.nodeValue.trim()) {
        var t = lookupFlexible(c.nodeValue.trim());
        if (t) {
          c.nodeValue = c.nodeValue.replace(c.nodeValue.trim(), t);
          replaced = true;
        }
      }
    }
    if (!replaced) node.textContent = translated;
    node.dataset.amourI18n = '1';
  }

  function translateAria(node) {
    if (!node || node.dataset.amourI18nAria === '1') return;
    var v = node.getAttribute('aria-label');
    var t = lookupFlexible(v);
    if (t) {
      node.setAttribute('aria-label', t);
      node.dataset.amourI18nAria = '1';
    }
  }

  function walkDrawerText(root) {
    if (!root) return;
    var TreeWalker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (n) {
          var v = n.nodeValue;
          if (!v) return NodeFilter.FILTER_REJECT;
          var t = v.trim();
          if (!t) return NodeFilter.FILTER_REJECT;
          if (!lookupFlexible(t)) return NodeFilter.FILTER_REJECT;
          var p = n.parentNode;
          if (p && p.nodeType === 1 && p.dataset && p.dataset.amourI18n === '1') {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        },
      },
      false
    );
    var node;
    while ((node = TreeWalker.nextNode())) {
      try {
        var orig = node.nodeValue;
        var t = orig.trim();
        var translated = lookupFlexible(t);
        if (translated && translated !== t) {
          node.nodeValue = orig.replace(t, translated);
          if (node.parentNode && node.parentNode.nodeType === 1) {
            node.parentNode.dataset.amourI18n = '1';
          }
        }
      } catch (_) { /* swallow */ }
    }
  }

  // Foxify wishlist + header AI pill leftovers (not Qikify, but same PL shim host)
  function localizePlStorefrontChrome() {
    if (loc !== 'pl') return;
    try {
      document.querySelectorAll('.frcp-wishlist-btn, [class*="frcp-wishlist"]').forEach(function (el) {
        ['aria-label', 'title'].forEach(function (attr) {
          var v = el.getAttribute(attr);
          if (!v) return;
          if (/add to wishlist/i.test(v)) el.setAttribute(attr, 'Dodaj do ulubionych');
          else if (/remove from wishlist/i.test(v)) el.setAttribute(attr, 'Usuń z ulubionych');
          else if (/in wishlist/i.test(v)) el.setAttribute(attr, 'W ulubionych');
        });
      });
      var pillLabel = document.querySelector('#amour-assistant-pill .amour-pill-label, #amour-assistant-pill span');
      if (pillLabel && /scent finder|ai scent/i.test(pillLabel.textContent || '')) {
        pillLabel.textContent = 'Asystent perfum';
      }
      var pill = document.getElementById('amour-assistant-pill');
      if (pill) {
        var aria = pill.getAttribute('aria-label') || '';
        if (/scent finder/i.test(aria)) pill.setAttribute('aria-label', 'Asystent perfum');
      }
    } catch (_) { /* swallow */ }
  }

  function scan() {
    try {
      document.querySelectorAll(TEXT_SELECTORS).forEach(function (n) {
        try { translateText(n); } catch (_) { /* swallow */ }
      });
      document.querySelectorAll(ARIA_SELECTORS).forEach(function (n) {
        try { translateAria(n); } catch (_) { /* swallow */ }
      });
      document.querySelectorAll(DRAWER_ROOTS).forEach(function (root) {
        try { walkDrawerText(root); } catch (_) { /* swallow */ }
      });
      localizePlStorefrontChrome();
    } catch (_) { /* swallow */ }
  }

  var scanTimer = null;
  function scheduleScan() {
    if (scanTimer) clearTimeout(scanTimer);
    scanTimer = setTimeout(scan, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleScan, { once: true });
  } else {
    scheduleScan();
  }

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (
        t &&
        t.nodeType === 1 &&
        (t.dataset && (t.dataset.amourI18n === '1' || t.dataset.amourI18nAria === '1'))
      ) {
        continue;
      }
      scheduleScan();
      return;
    }
  });
  mo.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['aria-label'],
  });
})();
